import React from 'react'
import ReactGA from 'react-ga'

import { LFCONNECT_URLS } from './GettingStartedConstants'
import CodeComponent from '../../../../core/CodeComponent/CodeComponent'

import './gettingStarted.scss'

class GettingStartedComponent extends React.Component {
    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Getting Started Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return <div className="getting-started">
            <div className="section">
                <h2>Getting Started</h2>
                <p>Developers wishing to access Halo Fitness API web services must be registered
                    in Halo Fitness Developer Portal as a third-party accessor before they will be able to access
                    the web services</p>
                <p className="bold">1. <span className="strawberry-text">Create a New License</span></p>
                <p>Click on the Licenses menu item and select a company. Then click on the Add button to create a new license.
                    The license creation form will be displayed. Fill in the required fields and click on the Submit button to create a new license.</p>

                <p className="bold">2. <span className="strawberry-text">Select Web API as the Enrollment Type</span></p>
                <p>The Redirect URL has to be provided. This is the URL of the application where the OAuth2 will
                    redirect after authentication. For more information about this, refer
                    to <a href="authentication" target="_blank" className='blue-text'>Authentication</a>.
                </p>

                <p className="bold">3. <span className="strawberry-text">Subscribe to Callback Events</span> <span className="optional-step">(Optional)</span></p>
                <p>During license creation, the developer can enter one or more facilities and subscribe to callback events by
                    providing a callback URL for each event. The subscription request is sent as a POST method.</p>
                <p>This step is optional and the license can be created without it. The developer can edit the license at any
                    time and add new facilities or remove existing facilities from the license. Any new facility added will need to be approved by the Life Fitness
                    team, and the license will remain in a pending stage until approved. For more details, refer to <a href="/api/web/structure/subscription" target="_blank" className='blue-text'>Subscription</a>.</p>

                <p className="bold">4. <span className="strawberry-text">OAuth Credentials</span></p>
                <p>Once a license is created, the developer can view the OAuth Client ID and an OAuth Client secret which are required to access the Partner APIs.
                    The license is always created in Development mode and can be moved to Production mode once the application is ready for production use.</p>

                <p className="bold">5. <span className="strawberry-text">Access the APIs</span></p>
                <p>The developer can begin using the APIs in the sandbox environment to test their application. To access user data, they have to be first created in the sandbox environment using the Partner API.
                    The user creation API returns the user's access token which is required to access the user's data.
                    The base URL for the sandbox environment is:</p>
                <CodeComponent type="url" code={LFCONNECT_URLS.sandbox_api} />

                <p className="bold">6. <span className="strawberry-text">Move the License to Production</span></p>
                <p>Once the developer's application is ready for production use, the license can be moved to the production mode.
                    The developer has to provide the production OAuth redirect URL.
                    The developer can optionally enter one or more production facilities and subscribe to callback events by providing a callback URL for each event.
                    The subscription request is sent as a POST method. Upon submission of the request, the license will display a pending icon if there are any facilities added.</p>

                <p className="bold">7. <span className="strawberry-text">Access the Production APIs</span></p>
                <p>Upon approval of any pending facility requests, the developer can begin using the APIs in the production environment to access real user data.
                The base URL for the production environment is:</p>
                <CodeComponent type="url" code={LFCONNECT_URLS.production_api} />
            </div>
        </div>
    }
}

export default GettingStartedComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/GettingStarted/Web/GettingStartedComponent.js